module.exports = __webpack_public_path__ + "static/img/caterium-ore_256.c3f4987.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/caterium-ore_256.png
// module id = RshL
// module chunks = 0